export const colors = {
  // Couleurs primaires
  primary: {
    gold: '#d8ae47',
    teal: '#007481',
    tealDark: '#005962',
    tealLight: '#5fa3ad', // Version éclaircie du teal (aligné avec mobile)
    gray: '#4f4e4e'
  },
  // Couleurs secondaires
  secondary: {
    lightBlue: '#3099bb',
    mediumGray: '#bebebe',
    lightTeal: '#aac9cf',
    lightGray: '#ebe8e8'
  },
  // Couleurs de texte
  text: {
    primary: '#4f4e4e',
    secondary: '#6b7280',
    dark: '#4f4e4e',
    light: '#bebebe',       // Texte clair (aligné avec mobile)
    placeholder: '#bebebe', // Placeholder (aligné avec mobile)
    white: '#ffffff',
    brown: '#92400e',
    darkRed: '#991b1b',
    darkGreen: '#166534',
    darkGreen2: '#065f46',
    darkOrange: '#b45309',
    goldDark: '#d97706',
    gray: '#4b5563',
    darkBlue: '#1e40af'
  },
  // Couleurs de fond
  background: {
    white: '#ffffff',
    light: '#f9fafb',
    input: '#f9fafb', // Fond des inputs (aligné avec mobile)
    lightBlue: '#f0f9ff',
    lightYellow: '#fffbeb',
    lightGreen: '#f0fdf4',
    lightRed: '#fee2e2',
    lightGray: '#f3f4f6',
    paleYellow: '#fef3c7',
    paleBlue: '#dbeafe',
    paleGreen: '#d1fae5'
  },
  // Couleurs de bordure
  border: {
    light: '#e5e7eb',
    medium: '#d1d5db'
  },
  // Couleurs de statut
  status: {
    success: '#10B981',
    error: '#EF4444',
    warning: '#F59E0B',
    info: '#3B82F6'
  },
  // Couleurs de survol (hover states)
  hover: {
    tealDark: '#005a64',
    goldDark: '#d97706',
    gold: '#c99d3a',
    errorDark: '#dc2626',
    successDark: '#059669'
  }
};